import styled from 'styled-components';

// Components
import ModalContainer from '../../containers/ModalContainer';
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';

/**
 * Confirmación destructiva, con la estructura canónica de la familia
 * (ForceCloseRouteModal / ConfirmTransferModal): overlay de Loader absoluto +
 * contenido atenuado, icono de alerta a su tamaño natural, bloque de texto
 * agrupado y fila de botones centrada.
 */
export const ModalContainerStyled = styled(ModalContainer)`
  position: relative;
`;

export const ContainerLoader = styled.div`
  position: absolute;
  top: 40%;
  left: 45%;
  z-index: 1;
`;

export const Container = styled.div<{ isLoading?: boolean }>`
  opacity: ${({ isLoading }) => (isLoading ? 0.6 : 1)};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  width: 100%;
  /*
    Sin padding horizontal propio: el ModalContainer ya aplica el suyo
    (spacing.xl). Sumarle el de ForceCloseRouteModal (6.35rem) estrechaba la
    columna de texto y partía el título y el aviso en demasiadas líneas.
  */
  padding: 0.5rem 0 1rem;
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
  /* Medida de lectura cómoda: ni línea kilométrica ni palabra por renglón. */
  max-width: 42rem;
`;

export const Text = styled(Typography)`
  text-align: center;
`;

export const Title = styled(Text)`
  font-size: 2.4rem;
`;

/** El nombre de lo que se va a borrar: destacado, sin caja gris. */
export const CompanyName = styled(Text)`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.garnet};
  word-break: break-word;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.m};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet *
    theme.percentBaseResponsive}rem) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

export const ActionButton = styled(MainButton)`
  min-width: 13.4rem;
  justify-content: center;
`;
